// src/pages/Dashboard.jsx (AJUSTADO PARA MOBILE HEADER)
import React, { useState, useEffect } from 'react';
import { usePositions } from '../hooks/usePositions';
import PositionCard from '../components/PositionCard';
import LoadingSpinner from '../components/LoadingSpinner';

const Dashboard = () => {
    const { data: positions = [], isLoading, error, refetch } = usePositions();
    const [count, setCount] = useState(60);

    useEffect(() => {
        const interval = setInterval(() => {
            setCount((prev) => {
                if (prev === 1) {
                    refetch(); // Refresca al llegar a 0
                    return 60; // Resetea a 60
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval); // Limpia al desmontar
    }, [refetch]);

    const handleRefresh = () => {
        refetch(); // Refresca inmediatamente
        setCount(60); // Resetea countdown
    };

    if (isLoading) return <LoadingSpinner />;

    if (error) return (
        <div className="alert alert-danger text-center m-4" role="alert">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            Error cargando posiciones: {error.message}
        </div>
    );

    const totalValue = positions.reduce((sum, p) => sum + p.valueUSD, 0);

    return (
        <div className="container-fluid px-2">
            <div className="row mb-2">
                <div className="col-12">
                    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-2">
                        <h2 className="h3 mb-2 mb-lg-0 fw-bold text-white">
                            <i className="bi bi-graph-up me-2 text-primary"></i>
                            Mis Posiciones ({positions.length})
                        </h2>
                        <div className="d-flex align-items-center justify-content-between justify-content-lg-end w-100 w-lg-auto">
                            <button
                                className="btn btn-outline-primary me-0 me-lg-3 d-flex align-items-center mb-2 mb-lg-0"
                                onClick={handleRefresh}
                                style={{ padding: '0.5rem 1rem', borderRadius: '8px' }}
                            >
                                <i className="bi bi-arrow-clockwise me-1"></i>
                                {count}s
                            </button>
                            <span className="badge bg-success fs-5 px-3 py-1 rounded-pill">
                ${totalValue.toFixed(2)}
              </span>
                        </div>
                    </div>
                </div>
            </div>

            {positions.length === 0 ? (
                <div className="col-12">
                    <div className="alert alert-info text-center rounded-pill">
                        <i className="bi bi-info-circle me-2"></i>
                        No tienes posiciones activas
                    </div>
                </div>
            ) : (
                <div className="row g-3 justify-content-start">
                    {positions.map((position) => (
                        <div key={position.tokenId} className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <PositionCard position={position} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Dashboard;